export const inputStatus = [
  { id: 1, label: 'Eligible ITC' },
  { id: 2, label: 'Ineligble ITC' },
  { id: 3, label: 'RCM ITC' },
];
